<template>
  <b-modal
    class="deleteClientModal"
    title="Delete Client"
    centered
    size="lg"
    ref="deleteClientModal"
    ok-title="Confirm"
    cancel-title="Cancel"
    @open="open"
    @ok="handleOk"
  >
    <b-alert show variant="light"
      >Are you really gonna delete this client?</b-alert
    >
    <b-loading :loading="processing" />
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      processing: false,
      initial: null,
    };
  },
  computed: {
    ...mapGetters(['error', 'loading']),
  },
  methods: {
    open(payload) {
      this.resetFormFields();
      this.initial = { ...payload };
      this.$refs.deleteClientModal.show();
    },
    close() {
      this.$refs.deleteClientModal.hide();
    },
    validate() {
      this.form.error.name = !this.form.name;
    },
    handleOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onSubmit() {
      this.onSubmitForm();
    },
    onCancel() {
      this.close();
    },
    onReset() {
      this.resetFormFields();
    },
    resetFormFields() {
      this.initial = null;
      this.processing = false;
    },
    onSubmitForm(e) {
      e && e.preventDefault();
      if (this.initial && !this.processing && !this.loading) {
        this.processing = true;
        this.$store.dispatch('deleteClient', this.initial).finally(() => {
          this.processing = false;
          this.close();
        });
      }
    },
  },
  created() {
    this.resetFormFields();
  },
};
</script>
<style>
.deleteClientModal .modal-header {
  border-bottom: 0 none;
}
.deleteClientModal .form-control {
  border: solid 1px #ccc;
}
.deleteClientModal .form-actions .btn {
  min-width: 100px;
}
</style>
